import React, { createContext, useContext, useState, useEffect } from 'react';

const CookieContext = createContext();

export const useCookieConsent = () => {
  const context = useContext(CookieContext);
  if (!context) {
    throw new Error('useCookieConsent must be used within CookieProvider');
  }
  return context;
};

export const CookieProvider = ({ children }) => {
  const [hasConsent, setHasConsent] = useState(null);

  useEffect(() => {
    // Check if user has previously given consent
    const consent = localStorage.getItem('cookieConsent');

    if (consent !== null) {
      setHasConsent(consent === 'true');
    }
  }, []);

  const giveConsent = (accepted) => {
    setHasConsent(accepted);
    localStorage.setItem('cookieConsent', accepted.toString());

    if (accepted) {
      // Initialize GA4 when consent is given
      initializeAnalytics();
    }
  };

  const denyConsent = () => {
    setHasConsent(false);
    localStorage.setItem('cookieConsent', 'false');
  };

  const resetConsent = () => {
    setHasConsent(null);
    localStorage.removeItem('cookieConsent');
  };

  const initializeAnalytics = () => {
    // This will be called from index.js after consent
    if (window.initGA4) {
      window.initGA4();
    }
  };

  return (
    <CookieContext.Provider value={{ hasConsent, giveConsent, denyConsent, resetConsent }}>
      {children}
    </CookieContext.Provider>
  );
};
